export const NETSUITE_FORM_FIELDS = {
  accountId: {
    label: 'Account ID',
  },
  companyId: {
    label: 'Company ID',
  },
  consumerKey: {
    label: 'Consumer Key',
  },
  consumerSecret: {
    label: 'Consumer Secret',
  },
  tokenId: {
    label: 'Access Token ID',
  },
  tokenSecret: {
    label: 'Access Token Secret',
  },
  customerLookup: {
    label: 'Matching Field for Customer Lookup',
    tooltip:
      'For Accounts in MonetizeNow that are not yet linked to a NetSuite Customer, select which field should be used to find an existing NetSuite Customer before creating a new customer.',
  },
  netsuiteProductExternalId: {
    label: 'NetSuite Item External ID',
    tooltip:
      "Field from the MonetizeNow product that will be used to match to an Item's external ID in NetSuite",
  },
  taxItemId: {
    label: 'NetSuite Item Id for Tax Line',
    tooltip:
      'NetSuite Item ID (i.e. Product) used on Invoices and Credit Notes for tax amounts.',
  },
};

export const RILLET_FORM_FIELDS = {
  apiKey: {
    label: 'API Key',
  },
  environment: {
    label: 'Environment',
  },
  defaultPaymentAccountCode: {
    label: 'Payment COA',
    tooltip:
      'Choose which account from your Chart of Accounts to use for payments.',
  },
};

export const XERO_FORM_FIELDS = {
  companyId: {
    label: 'Company',
    tooltip:
      'Select the Xero company/organization you want to sync with MonetizeNow',
  },
  defaultPaymentCoa: {
    label: 'Payment COA',
    tooltip:
      'Choose which account from your Chart of Accounts to use for payments.',
  },
  defaultProductCoa: {
    label: 'Product COA',
    tooltip:
      'Choose the default account from your Chart of Accounts to use for products. You can override the account to use for individual products by specifying the "Finance ID"',
  },
  name: {
    label: 'Name',
  },
  email: {
    label: 'Email',
  },
  userId: {
    label: 'User ID',
  },
  userName: {
    label: 'User Name',
  },
};
